import { HelpButton } from "@/components/HelpButton/HelpButton";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <div className="flex items-center gap-2">
      <HelpButton />
      <span className="text-muted-foreground text-xs">
        Hover for the tooltip, click to open the help center in a new tab.
      </span>
    </div>
  );
}

function OnSurfaces() {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center rounded-md bg-muted p-2">
        <HelpButton />
      </div>
      <div className="flex items-center rounded-md border border-border p-2">
        <HelpButton />
      </div>
    </div>
  );
}

export function PlaygroundHelpButton() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>On Surfaces</PlaygroundSubSectionTitle>
        <OnSurfaces />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
